import { TextField } from "@mui/material";
import { useTarefa } from "../../../../contexts/TarefaContext";

const NomeTarefa = () => {
    const [tarefa, setTarefa] = useTarefa();

    function handleNomeAlterado(event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>): void {
        event.preventDefault();
        
        setTarefa({ ...tarefa, nome: event.target.value });
    }

    return (
        <TextField
            id="nome"
            name="nome"
            label="Nome tarefa"
            variant="outlined"
            required
            onChange={handleNomeAlterado}
            value={tarefa.nome} />
    )
}

export default NomeTarefa;